// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bhm_h bhm_kh bhm_we bhm_su bhm_vt bhm_sw bhm_sn"};